import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

const LinkIcon = (props) => {
    return (
        <SvgIcon {...props}>
            <path
                fill="#231F20"
                d={`M11.5,17.5c-0.2,0-0.2,0-0.3,0.2c-1,1-2.1,2.1-3.1,3.1c-0.9,1-2.1,1.2-3.3,0.9c-1.2-0.3-2.1-1.2-2.4-2.4
                    c-0.3-1.4,0-2.4,1-3.2c1.5-1.7,3.3-3.2,4.8-4.8c1.7-1.7,4.6-1.2,5.5,1c0.2,0.3,0.2,0.3,0.5,0.2c0.2,0,0.2,0,0.3-0.2
                    c0.3-0.3,0.7-0.7,1.2-1c0.2-0.2,0.2-0.2,0-0.3c-0.5-1-1.2-1.7-2.1-2.2c-1.2-0.7-2.6-0.9-4-0.7C8.6,8.1,7.5,8.6,6.8,9.4
                    c-1.7,1.7-3.4,3.4-5.2,5.1c-2.2,2.2-2.2,5.8,0,8c1.2,1,2.6,1.5,4.1,1.4c1.2-0.2,2.4-0.5,3.3-1.4c1.7-1.5,3.3-3.2,4.8-4.8l0.2-0.2
                    C13.2,17.6,12.4,17.6,11.5,17.5z M22.3,1.4c-1.2-1-2.6-1.5-4.1-1.4c-1.2,0.2-2.4,0.5-3.3,1.4c-1.7,1.5-3.3,3.2-4.8,4.8L9.9,6.4
                    c0.9-0.2,1.7-0.2,2.6,0c0.2,0,0.2,0,0.3-0.2c1-1,2.1-2.1,3.1-3.1c0.9-1,2.1-1.2,3.3-0.9c1.2,0.3,2.1,1.2,2.4,2.4
                    c0.3,1.4,0,2.4-1,3.2c-1.5,1.7-3.3,3.2-4.8,4.8c-1.7,1.7-4.6,1.2-5.5-1c-0.2-0.3-0.2-0.3-0.5-0.2c-0.2,0-0.2,0-0.3,0.2
                    c-0.3,0.3-0.7,0.7-1.2,1c-0.2,0.2-0.2,0.2,0,0.3c0.5,1,1.2,1.7,2.1,2.2c1.2,0.7,2.6,0.9,4,0.7c1-0.2,2.1-0.7,2.8-1.5
                    c1.7-1.7,3.4-3.4,5.2-5.1C24.6,7.2,24.6,3.6,22.3,1.4z`}
            />
        </SvgIcon>
    );
};

export default LinkIcon;
